$('form').on('change', '[data-ptffrom], [data-ptfto]', function (e){
    var $input = $(e.target);
    if ($input.hasClass('date-range-from')) {
        if ($input.val() < $input.data('ptffrom')) {
            showPTFUpload($input);
        }
    } else if ($input.hasClass('date-range-to')) {
        if ($input.val() > $input.data('ptfto')) {
            showPTFUpload($input);
        }
    }
})

function showPTFUpload(input) {
    var $uploadInput = $(input).closest('.ptf_date').parent().find('.ptf_file');
    $uploadInput.removeClass("d-none")
}